// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"489":"component---src-templates-landing-page-template-index-tsx","532":"styles","774":"framework","856":"42d084c6"}[chunkId] || chunkId) + "-" + {"489":"d5a8d8872093213fbb76","532":"da43094a3b866891d451","589":"faf503b060eaf38cf630","774":"e16140bb03dcf25bf8c4","856":"a6ee7742df99a38352a9"}[chunkId] + ".js";
};